<template>
  <div :class="{ 'no-page-break': keepTogetherOnPrint }" style="padding:5px; padding-bottom: 20px;">
    <div class="field">
      <label class="label">
        <span class="question-title" v-html="text"></span>
        <span v-if="tip">
          <i class="far fa-question-circle" v-tooltip="tooltip"></i>
        </span>
      </label>

    </div>
    <!--'input'-->
    <div v-if="type == 'text' || type == 'number' || type == 'textarea' || !type">
      <b-input v-model="data"
              :placeholder="placeholder"
              :maxlength="maxlength"
              :readonly="readonly"
              has-counter
              :type="inputType"
              class="is-web-only"></b-input>
      <div v-html="data" class="is-print-only"></div>
    </div>
    <!--'datepicker'-->
    <div v-if="type == 'date' || type == 'datepicker'">
      <div class="is-web-only">
        <b-field style="width: 175px;">
          <b-datepicker v-model="data"
                        ref="datepicker"
                        :placeholder="placeholder"
                        editable
                        expanded
                        :min-date="new Date(2000,0,1)"
                        :disabled="readonly"></b-datepicker>
          <b-button type="is-primary" @click="ToggleDatepicker()" icon-left="calendar-alt" :disabled="readonly"></b-button>
        </b-field>
      </div>
      <div class="is-print-only">
        <span>{{data | moment('MM/DD/YYYY')}}</span>
      </div>
    </div>
    <!--'select'-->
    <div v-if="type == 'select'">
      <div class="is-web-only">
        <b-select v-model="data"
                  :placeholder="placeholder"
                  :disabled="readonly"
                  expanded>
          <slot></slot>
        </b-select>
      </div>
      <div class="is-print-only">
        <span>{{data}}</span>
      </div>
    </div>
    <!--'radio'-->
    <div v-if="type == 'radio'">
      <div class="is-block wrap" v-if="!column">
        <div class="is-web-only">
          <b-radio style="padding: 5px;" v-model="data" :name="r" v-for="opt in Options" :key="`radio-web-${r}-${opt.key}`" :native-value="opt.key"
                   :disabled="readonly">
            {{opt.text}}
            <span v-if="opt.tip">
              <i class="far fa-question-circle" v-tooltip="Tooltip(opt.tip)"></i>
            </span>
          </b-radio>
        </div>
        <div class="is-print-only">
          <div>{{selectedRadioText}}</div>
        </div>
      </div>
      <div class="is-block" v-if="column">
        <div v-for="opt in Options" :key="`radio-column-${r}-${opt.key}`" class="is-web-only">
          <b-radio style="padding: 5px;" v-model="data" :name="r" :native-value="opt.key"
                   :disabled="readonly">
            {{opt.text}}
            <span v-if="opt.tip">
              <i class="far fa-question-circle" v-tooltip="Tooltip(opt.tip)"></i>
            </span>
          </b-radio>
        </div>
        <div class="is-print-only">
          <div>{{selectedRadioText}}</div>
        </div>
      </div>
    </div>
    <!--'checkbox'-->
    <div v-if="type == 'checkbox'">
      <div class="is-block wrap" v-if="!column">
        <div class="is-web-only">
          <b-checkbox style="padding: 5px;" v-model="data" v-for="opt in Options" :key="`checkbox-web-${r}-${opt.key}`" :native-value="opt.key"
                      type="is-primary"
                      :disabled="readonly">
            {{opt.text}}&nbsp;
            <span v-if="opt.tip">
              <i class="far fa-question-circle" v-tooltip="Tooltip(opt.tip)"></i>
            </span>
          </b-checkbox>
        </div>
        <div class="is-print-only">
          <div v-for="opt in selectedCheckboxOptions" :key="`checkbox-print-${r}-${opt.key}`">{{opt.text}}</div>
        </div>
      </div>
      <div class="is-block" v-if="column">
        <div v-for="opt in Options" :key="`checkbox-column-${r}-${opt.key}`" style="margin-bottom: 5px;" class="is-web-only">
          <b-checkbox style="padding: 5px;" v-model="data" :native-value="opt.key"
                      type="is-primary"
                      :disabled="readonly">
            {{opt.text}}&nbsp;
            <span v-if="opt.tip">
              <i class="far fa-question-circle" v-tooltip="Tooltip(opt.tip)"></i>
            </span>
          </b-checkbox>
        </div>
        <div class="is-print-only">
          <div v-for="opt in selectedCheckboxOptions" :key="`checkbox-column-print-${r}-${opt.key}`">{{opt.text}}</div>
        </div>
      </div>
    </div>
    <!--'autocomplete'-->
    <div v-if="type == 'autocomplete'">
      <div class="is-web-only">
        <b-autocomplete v-model="data"
                        :data="options"
                        :placeholder="placeholder"
                        expanded
                        :disabled="readonly"
                        :open-on-focus="openOnFocus && !readonly"></b-autocomplete>
      </div>
      <div class="is-print-only">
        <span>{{data}}</span>
      </div>
    </div>
    <!--'tags'-->
    <div v-if="type == 'tags'">
      <div class="is-web-only">
        <b-taginput v-model="data"
                    :data="filteredOptions"
                    autocomplete
                    @typing="getFilteredTags"
                    :placeholder="placeholder"
                    ellipsis
                    :readonly="readonly"
                    :open-on-focus="openOnFocus && !readonly"></b-taginput>
      </div>
      <div class="is-print-only">
        <span>{{data}}</span>
      </div>
    </div>
    <!--'wysiwyg'-->
    <div v-if="type == 'wysiwyg'">
      <div class="is-web-only">
        <editor apiKey="0qgi7f55b2ue7vvn7vvi7w9zim05110j4aznns846hbq588x"
                v-model="data"
                :disabled="readonly"
                :init="{
                    menubar: false,
                    plugins: [
                    'autoresize',
                    'wordcount'
                    ],
                    toolbar:
                    'formatselect | bold italic underline | \
                    bullist numlist outdent indent | removeformat | spellchecker',
                    browser_spellcheck: true
       }"></editor>
      </div>
      <div v-html="Html" class="is-print-only"></div>
    </div>
  </div>
</template>
<script>
  import Editor from '@tinymce/tinymce-vue'
  export default {
    name: "question",
    components: {
      'editor': Editor
    },
    data() {
      return {
        data: undefined,
        inputType: 'text',
        r: 0,
        filteredOptions: this.options,
        tooltip: {
          delay: { show: 50, hide: 100 },
          autoHide: false,
          html: true,
          content: ''
        },
      }
    },
    props: {
      "value": [String, Array, Object, Date, Number],
      "type": String,
      "text": String,
      "placeholder": String,
      "maxlength": String,
      "readonly": Boolean,
      "tip": String,
      "options": Array,
      "optionKey": [String, Number],
      "optionText": [String, Number],
      "openOnFocus": Boolean,
      "column": Boolean
    },
    computed: {
      Options() {
        if (this.options) {
          if (this.options.every(o => (typeof o) == "string")) {
            return this.options.map(o => {
              return { "key": o, "text": o };
            });
          }
          else if (this.options.every(o => (typeof o) == "object")) {
            var key = this.optionKey || "key";
            var text = this.optionText || "text";
            return this.options.map(o => {
              return {
                "key": o[key],
                tip: o.tip,
                "text": o[text]
              }
            });
          }
          else {
            console.error("v-bind:options contains an invalid structure.");
            return [];
          }
        }
        else {
          return [];
        }
      },
      Html() {
        if (this.data) {
          return this.data.replace(/\n/g, '<br/>');
        }
        else
          return '';
      },
      selectedRadioText() {
        var selected = this.Options.find(o => o.key == this.data);
        if (selected)
          return selected.text;
        return '';
      },
      selectedCheckboxOptions() {
        if (!Array.isArray(this.data))
          return [];
        return this.Options.filter(opt => this.data.some(d => d == opt.key));
      },
      keepTogetherOnPrint() {
        return this.type != "wysiwyg";
      }
    },
    methods: {
      Update(val) {
        this.$emit('input', val);
      },
      ToggleDatepicker() {
        var datepicker = this.$refs.datepicker;
        if (!datepicker.isFocused) {
          setTimeout(() => {
            this.$refs.datepicker.toggle();
          }, 10);
        }
      },
      getFilteredTags(text) {
        this.filteredOptions = this.options.filter(opt => opt.toLowerCase().indexOf(text.toLowerCase()) > -1);
      },
      Tooltip(content) {
        return {
          autoHide: false,
          html: true,
          content: content
        }
      }
    },
    watch: {
      value: {
        handler(n, o) {
          this.data = n;
        },
        deep: false
      },
      data: {
        handler(n, o) {
          this.Update(n);
        },
        deep: false
      }
    },
    created() {
      this.r = Math.floor(Math.random() * 1000000000000).toString() + Math.floor(Math.random() * 1000000000000).toString(); //remove name collisions on radio buttons
      if (this.type !== undefined)
        this.inputType = this.type;

      this.tooltip.content = this.tip;

      if (this.value !== undefined && this.value !== null) {
        if (this.type == "checkbox" && !Array.isArray(this.value)) {
          this.data = [this.value];
        }
        else
          this.data = this.value;
      }
      else {
        if (this.type == "checkbox")
          this.data = [];
      }

    },
    mounted() {

    }
  }
</script>
<style>
  .wrap label.b-checkbox.checkbox + .checkbox, .wrap label.b-radio.radio + .radio {
    margin-left: 0;
  }

  .wrap label.checkbox, .wrap label.radio {
    margin-right: 0.5em;
  }
</style>
